const DAYS = {
    MONDAY: 'Måndag',
    TUESDAY: 'Tisdag',
    WEDNESDAY: 'Onsdag',
    THURSDAY: 'Torsdag',
    FRIDAY: 'Fredag',
    SATURDAY: 'Lördag',
    SUNDAY: 'Söndag'
};

const CATEGORIES = {
    COFFEE: 'Äta/Fika',
    SHOP: 'Shoppa',
    EXPERIENCE: 'Uppleva',
    CARE_HEALTH: 'Vård & Hälsa'
};

const OPENING_HOURS = [{
    id: 0,
    title: CATEGORIES.COFFEE,
    hours: [{
        id: 0,
        day: DAYS.MONDAY,
        hours: '07–04'
    }, {
        id: 1,
        day: DAYS.TUESDAY,
        hours: '07–04'
    }, {
        id: 2,
        day: DAYS.WEDNESDAY,
        hours: '07–04'
    }, {
        id: 3,
        day: DAYS.THURSDAY,
        hours: '07–04'
    }, {
        id: 4,
        day: DAYS.FRIDAY,
        hours: '07–04'
    }, {
        id: 5,
        day: DAYS.SATURDAY,
        hours: '07–04'
    }, {
        id: 6,
        day: DAYS.SUNDAY,
        hours: '07–04'
    }]
}, {
    id: 1,
    title: CATEGORIES.SHOP,
    hours: [{
        id: 0,
        day: DAYS.MONDAY,
        hours: '10-20'
    }, {
        id: 1,
        day: DAYS.TUESDAY,
        hours: '10-20'
    }, {
        id: 2,
        day: DAYS.WEDNESDAY,
        hours: '10-20'
    }, {
        id: 3,
        day: DAYS.THURSDAY,
        hours: '10-20'
    }, {
        id: 4,
        day: DAYS.FRIDAY,
        hours: '10-20'
    }, {
        id: 5,
        day: DAYS.SATURDAY,
        hours: '10-18'
    }, {
        id: 6,
        day: DAYS.SUNDAY,
        hours: '10-18'
    }]
}, {
    id: 2,
    title: CATEGORIES.EXPERIENCE,
    hours: [{
        id: 0,
        day: DAYS.MONDAY,
        hours: '10-00'
    }, {
        id: 1,
        day: DAYS.TUESDAY,
        hours: '10-00'
    }, {
        id: 2,
        day: DAYS.WEDNESDAY,
        hours: '10-00'
    }, {
        id: 3,
        day: DAYS.THURSDAY,
        hours: '10-00'
    }, {
        id: 4,
        day: DAYS.FRIDAY,
        hours: '10-00'
    }, {
        id: 5,
        day: DAYS.SATURDAY,
        hours: '10-00'
    }, {
        id: 6,
        day: DAYS.SUNDAY,
        hours: '10-00'
    }]
}, {
    id: 3,
    title: CATEGORIES.CARE_HEALTH,
    hours: [{
        id: 0,
        day: DAYS.MONDAY,
        hours: '07-21'
    }, {
        id: 1,
        day: DAYS.TUESDAY,
        hours: '07-21'
    }, {
        id: 2,
        day: DAYS.WEDNESDAY,
        hours: '07-21'
    }, {
        id: 3,
        day: DAYS.THURSDAY,
        hours: '07-21'
    }, {
        id: 4,
        day: DAYS.FRIDAY,
        hours: '07-21'
    }, {
        id: 5,
        day: DAYS.SATURDAY,
        hours: '08-21'
    }, {
        id: 6,
        day: DAYS.SUNDAY,
        hours: '08-21'
    }]
}];

export {
    OPENING_HOURS
};
